// validate functions
export const isValidPassword = (password) =>
    /^(?=.*[\d])[a-zA-Z0-9!@#$%^&*]{8,16}$/.test(password);

export const isValidEmail = (email) =>
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(email);

// regex constants
export const GroupNameRegex = /^[^~`!@#$%^*(){}:;"<>?/[\]\|\\]*$/i;